<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <!--       <b-alert
        v-for="warning in current_warnings"
        :key="JSON.stringify(warning)"
        show
        variant="info"
      >
        {{ $t(warning) }}
      </b-alert> -->
      <b-form-group>
        <label>
          <b> {{ $t('table_chosen') }} </b>
        </label>
        <b-form-select v-model="table" :options="table_options" />
      </b-form-group>
      <b-form-group>
        <label>
          <b> {{ $t('const_col_name') }} </b>
        </label>
        <manual-column-name v-model="const_generic_colname" />
      </b-form-group>
      <b-form-group>
        <label>
          <b> {{ $t('const_col_type') }} </b>
        </label>
        <b-form-radio v-model="const_type" value="number">
          {{ $t('number') }}
          <span
            v-c-tooltip="$t('number_format_tooltip')"
            class="fas fa-question-circle"
          />
        </b-form-radio>
        <b-form-radio v-model="const_type" value="string">
          {{ $t('text') }}
        </b-form-radio>
        <b-form-radio v-model="const_type" value="date">
          {{ $t('date') }}
          <span
            v-c-tooltip="$t('date_format_tooltip')"
            class="fas fa-question-circle"
          />
        </b-form-radio>
        <b-form-radio v-model="const_type" value="bool">
          {{ $t('boolean') }}
        </b-form-radio>
      </b-form-group>

      <b-form-group>
        <label>
          <b> {{ $t('const_col_value') }} </b>
        </label>
        <b-form-input
          v-if="const_type !== 'bool'"
          v-model="const_value"
          :placeholder="$t('enter_value')"
        />
        <b-form-select
          v-else
          v-model="const_boolean_value"
          :options="boolean_select_options"
        />
      </b-form-group>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "const_col_name": "Name of the created constant column",
    "const_col_type": "Type of the created constant column",
    "const_col_value": "Value of the created constant column",
    "enter_name": "Enter the name you want for the column",
    "enter_value": "Enter the value you want for the column",
    "date_format_tooltip": "At the RFC 3339 or ISO 8601 format (\"%Y-%m-%dT%H:%M:%SZ\" for instance) 'NaT' for missing value",
    "number_format_tooltip": "'NaN' for missing value",
    "cwrw_column_name_overridden": "The column name chosen already exists, it will overwrite the column"
  },
  "fr": {
    "const_col_name": "Nom donné à la nouvelle colonne constante",
    "const_col_type": "Type de la nouvelle colonne constante",
    "const_col_value": "Valeur donnée à la nouvelle colonne constante",
    "enter_name": "Entrez la valeur souhaitée pour la colonne",
    "date_format_tooltip": "Au format selon le RFC 3339 ou le standard ISO 8601 (\"%Y-%m-%dT%H:%M:%SZ\" par exemple) 'NaT' pour valeur manquante",
    "number_format_tooltip": "'NaN' pour valeur manquante",
    "cwrw_column_name_overridden": "Le nom de colonne choisi existe déjà, la colonne d'origine sera supprimée"
  }
}
</i18n>

<script>
import _ from 'lodash'

// import {
//   subscription_mixin,
//   brick_mixin,
//   brick_with_single_parent_mixin,
//   metavariables_tracking_info_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'

import {
  BasicTableInfoEntity,
  GenericColumnName,
} from '@/components/object_model.js'
import ManualColumnName from '@/components/manual_column_name.vue'

// *****************************************************************************

export default {
  name: 'BrickAddConstColumn',
  components: {
    ManualColumnName,
  },
  // mixins: [
  //   subscription_mixin,
  //   brick_mixin,
  //   brick_with_single_parent_mixin,
  //   metavariables_tracking_info_mixin,
  // ],

  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      const_generic_colname: new GenericColumnName(),
      const_type: 'number',
      const_value: '',
      const_boolean_value: true,
    }
  },

  computed: {
    boolean_select_options() {
      const res = [
        { value: true, text: this.$t('true') },
        { value: false, text: this.$t('false') },
      ]

      return res
    },
    // adapted_data() {
    //   // N.B PL : Not sure if here we need to create the basic table info entity
    //   // but I think so, so for now I do it here but we may want
    //   // to generalize the system of going from info to uid and vice-versa
    //   let extended_table_info = []
    //   if (this.table !== -1) {
    //     let parent_info_entity_type = new BasicTableInfoEntity()
    //     parent_info_entity_type.uid = this.table
    //     extended_table_info.push(parent_info_entity_type)
    //   }
    //   let adapted = {
    //     uid: this.brick_id,
    //     parents_info: extended_table_info,
    //     const_colname: this.const_generic_colname,
    //     const_type: this.const_type,
    //     const_value: this.const_value,
    //   }

    //   _.assignIn(adapted, this.description_name)

    //   return adapted
    // },

    adapted_data() {
      // N.B PL : Not sure if here we need to create the basic table info entity
      // but I think so, so for now I do it here but we may want
      // to generalize the system of going from info to uid and vice-versa
      let extended_table_info = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        extended_table_info.push(parent_info_entity_type)
      }

      let value

      if (this.const_type === 'bool') {
        value = this.const_boolean_value
      } else {
        value = this.const_value
      }

      let adapted = {
        uid: this.brick_id,
        parents_info: extended_table_info,
        const_colname: this.const_generic_colname,
        const_type: this.const_type,
        const_value: value,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    // cur_brick: {
    //   immediate: true,
    //   handler(new_val) {
    //     // N.B PL : May not be necessary
    //     new_val = new_val || {}
    //     // N.B PL : This may be problematic, we may want the uid and not
    //     // the info entity type ?
    //     // So for now I changed it so we get the uid directly
    //     this.table = (new_val.parents_info[0] || {}).uid || -1
    //     this.const_generic_colname = new_val.const_colname
    //     this.const_type = new_val.const_type
    //     this.const_value = new_val.const_value
    //   },
    // },

    cur_brick: {
      immediate: true,
      handler(new_val) {
        // N.B PL : May not be necessary
        new_val = new_val || {}
        // N.B PL : This may be problematic, we may want the uid and not
        // the info entity type ?
        // So for now I changed it so we get the uid directly
        this.table = (new_val.parents_info[0] || {}).uid || -1
        this.const_generic_colname = new_val.const_colname
        this.const_type = new_val.const_type

        if (new_val.const_type === 'bool') {
          this.const_boolean_value = new_val.const_value
          this.const_value = ''
        } else {
          this.const_boolean_value = null
          this.const_value = new_val.const_value
        }
      },
    },
  },
}
</script>
